import type { FilterOption } from "Components/Shared/Filters/FilterOption";
import { determineDatesByPeriod } from "Components/Transactions/utils/transactionFilterUtils";
import type { CardTransactionStatus } from "Infrastructure/Api/Api";
import type { TimePeriod } from "Types/TimePeriod";

export type CardTransactionFilters = {
  timePeriod?: TimePeriod;
  dateFrom?: Date;
  dateTo?: Date;
  payPoint?: FilterOption;
  employee?: FilterOption;
  status?: CardTransactionStatus;
  isRefundOrCancellation?: boolean;
};

export const INITIAL_CARD_TRANSACTION_FILTERS: CardTransactionFilters = {
  timePeriod: "month",
};

export type CardTransactionQueryParams = {
  dateFrom?: string;
  dateTo?: string;
  payPointPublicID?: string;
  employeePublicID?: string;
  status?: CardTransactionStatus;
  isRefundOrCancellation?: boolean;
};

export const cardFiltersToQueryParams = (
  filters: CardTransactionFilters | undefined,
): CardTransactionQueryParams => {
  const { dateFrom, dateTo } = determineDatesByPeriod(filters ?? {});

  return {
    dateFrom,
    dateTo,
    status: filters?.status,
    payPointPublicID: filters?.payPoint?.publicID,
    employeePublicID: filters?.employee?.publicID,
    isRefundOrCancellation: filters?.isRefundOrCancellation,
  };
};
